// extracted by mini-css-extract-plugin
export var lg = "_2b-4";
export var md = "_2b-3";
export var sm = "_2b-2";
export var xs = "_2b-1";
export var xxs = "_2b-0";